/**
 * Выбор оболочки embed (контур): мобильное приложение, тренерское приложение, виджет записи и т.д.
 *
 * Приоритет: явный `?wn=` → мобильное приложение (`widget_channel=mobile`) → `widget_name` организации.
 * Для мобильного канала без `wn` контур выводится из пути: `/trainer…` — тренерское приложение,
 * остальное — клиентское. Так уже установленные сборки приложений получают мобильную оболочку,
 * даже если при навигации `wn` выпал из адреса.
 */

export type WidgetContour = 'booking' | 'client' | 'trainer' | 'trainer-mobile' | 'mobile';

export type ResolveWidgetContourInput = {
  wnParam: string | null;
  widgetChannel: string | null;
  pathname: string;
  widgetName: string | null;
  hasGuestShowcaseOrg: boolean;
};

function isTrainerPath(pathname: string): boolean {
  return pathname === '/trainer' || pathname.startsWith('/trainer/');
}

function contourFromName(name: string): WidgetContour {
  if (name === 'trainer-mobile') return 'trainer-mobile';
  if (name === 'trainer') return 'trainer';
  if (name === 'mobile') return 'mobile';
  return 'booking';
}

export function resolveWidgetContour(input: ResolveWidgetContourInput): WidgetContour | null {
  const wn = input.wnParam?.trim() || null;
  if (wn) return contourFromName(wn);
  if (input.widgetChannel === 'mobile') {
    return isTrainerPath(input.pathname) ? 'trainer-mobile' : 'mobile';
  }
  const name = input.widgetName?.trim() || null;
  if (name) return contourFromName(name);
  return input.hasGuestShowcaseOrg ? 'booking' : null;
}
